export const DEFAULT_DRIVE_EDITOR_ID = "powerhouse/generic-drive-explorer";
export const COMMON_PACKAGE_ID = "powerhouse/common";
